import {SimpleTextField} from './SimpleTextField';

/**
 * German-specific vehicle registration fields (HSN, TSN)
 * Simple component that renders the registration number fields
 */
export function GermanSpecificFields() {
  return (
    <>
      <SimpleTextField name="hsn" />
      <SimpleTextField name="tsn" />
    </>
  );
}
